<div class="header-bar">
  <h1>Organisation Structure</h1>
</div>
<div class="content-container">
  <div *ngIf="customerorgId > 0">
    <org-structure [org_type]="'customer'"></org-structure>
  </div>
  <h4 *ngIf="customerorgId == 0">No Organisation Attached to this User</h4>

  <div *ngIf="backTo" class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="close()"
      class="btn-to-right"
      icon="fa ui-icon-close"
      pButton
      label="Close"
    ></button>
  </div>
</div>
